import { InjectionToken, Provider } from '@angular/core';
import { ImageChatMessageService } from './image-chat-message.service';
import { ImageChatRealtimeService } from './image-chat-realtime.service';

export const IMAGE_CHAT = new InjectionToken<boolean>('IMAGE_CHAT');

export function provideImageChat(): Provider[] {
  return [ImageChatRealtimeService, ImageChatMessageService, { provide: IMAGE_CHAT, useValue: true }];
}
